var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"test",on:{"click":function($event){return _vm.$emit('open', _vm.test)}}},[_c('p',[(_vm.showIcon)?_c('status-icon',{attrs:{"status":_vm.test.status}}):_vm._e(),_vm._v(" "+_vm._s(_vm.test.name)+" ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }